import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { getSort } from "@faire/retailer-shared/filters/getFilterOptions";
import { FilterSection } from "@faire/retailer-visitor-shared/components/Filters/__internal__/FilterSection";
import { useFilterStore } from "@faire/retailer-visitor-shared/components/Filters/useFilterStore";
import { Chevron } from "@faire/web--source/slate/icons/Chevron";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import ClickOutside from "@faire/web--source/ui/ClickOutside";
import { trackRetailersFilterInteraction } from "@faire/web-api--source/events/retailers/actionUnknown/filterInteraction";
import { trackRetailersFilterClickedClick } from "@faire/web-api--source/events/retailers/click/filterClicked";
import React from "react";
import styled, { css } from "styled-components";
export var Sort = function(param) {
    var name = param.name, className = param.className, roundCorners = param.roundCorners;
    var _useFilterStore = useFilterStore([
        "filterSections"
    ]), filterSections = _useFilterStore.data.filterSections, setFilterState = _useFilterStore.setFilterState;
    var _React_useState = _sliced_to_array(React.useState(false), 2), isFlyoutOpen = _React_useState[0], setIsFlyoutOpen = _React_useState[1];
    var sortSection = getSort(filterSections);
    if (!sortSection) {
        return null;
    }
    var handleFlyoutToggle = function(event) {
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        event === null || event === void 0 ? void 0 : event.preventDefault();
        var _sortSection_field_name;
        trackRetailersFilterInteraction(name, !isFlyoutOpen ? "expand_section" : "collapse_section", (_sortSection_field_name = sortSection.field_name) !== null && _sortSection_field_name !== void 0 ? _sortSection_field_name : "");
        setIsFlyoutOpen(!isFlyoutOpen);
    };
    var handleFilterSelected = function(_section, filterKey, _value) {
        trackRetailersFilterClickedClick(name, filterKey);
        setFilterState(function(currentState) {
            return _object_spread_props(_object_spread({}, currentState), {
                isNewFilterSelected: true
            });
        });
        handleFlyoutToggle();
    };
    return /*#__PURE__*/ _jsxs(Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ _jsxs(Header, {
                onClick: handleFlyoutToggle,
                $roundCorners: roundCorners,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraphSansRegular",
                        style: {
                            textWrap: "nowrap"
                        },
                        children: sortSection === null || sortSection === void 0 ? void 0 : sortSection.pill_text
                    }),
                    /*#__PURE__*/ _jsx(StyledChevron, {
                        direction: isFlyoutOpen ? "up" : "down",
                        fontSize: "12px",
                        color: Core.icon.default
                    })
                ]
            }),
            isFlyoutOpen ? /*#__PURE__*/ _jsx(ClickOutside, {
                onClickOutside: handleFlyoutToggle,
                children: /*#__PURE__*/ _jsx(Flyout, {
                    children: /*#__PURE__*/ _jsx(FilterSection, {
                        section: sortSection,
                        name: name,
                        initiallyCollapsed: false,
                        collapsable: false,
                        onChange: handleFilterSelected,
                        showAll: true
                    })
                })
            }) : null
        ]
    });
};
var Wrapper = styled.div.withConfig({
    componentId: "sc-64811631-0"
})([
    "position:relative;width:max-content;height:100%;cursor:pointer;",
    "{display:none;}"
], responsiveMediaQueries.tabletAndBelow);
var Flyout = styled(Column).withConfig({
    componentId: "sc-64811631-1"
})([
    "width:200px;height:auto;max-height:486px;background:",
    ";box-shadow:0 7px 10px rgba(0,0,0,0.1);position:absolute;padding-left:",
    ";padding-right:",
    ";top:42px;right:0;cursor:default;z-index:12;"
], Core.surface.inverse, getSpacing("3x"), getSpacing("3x"));
export var Header = styled(Row).attrs({
    justify: "space-between",
    align: "center"
}).withConfig({
    componentId: "sc-64811631-2"
})([
    "width:100%;height:100%;background:white;top:0;z-index:10;border:1px solid ",
    ";padding:",
    ";",
    ""
], Core.border.muted, getSpacing(9, "2x"), function(param) {
    var $roundCorners = param.$roundCorners;
    return $roundCorners ? css([
        "border-radius:",
        ";"
    ], getSpacing(20)) : null;
});
var StyledChevron = styled(Chevron).withConfig({
    componentId: "sc-64811631-3"
})([
    "margin-left:",
    ";"
], getSpacing("1x"));
